import { TextBlockConfigurationRecord } from "models/view-models/block-configurations/text-block-configuration-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface TextBlockConfigurationUpdatePathParams {
    configurationId: number;
}

export interface TextBlockConfigurationUpdatePutParams {
    content: string;
}

const resourceEndpoint: string = "blocks/configurations/text/:configurationId";
const resourceType = TextBlockConfigurationRecord;

const TextBlockConfigurationService = {
    useUpdate: ServiceHookFactory.useUpdateFromPutParams<
        TextBlockConfigurationRecord,
        TextBlockConfigurationUpdatePutParams,
        TextBlockConfigurationUpdatePathParams
    >(resourceType, resourceEndpoint),
};

export default TextBlockConfigurationService;
